import {
  Chat,
  ChatStatus,
  ChatType,
  ContactabilityStatus,
} from '@tribeplatform/gql-client/types'
import { useCheckMembersContactability } from '@tribeplatform/react-sdk/hooks'

import { useI18n } from '../../i18n/index.js'
import { ComposerLoadingSkeleton } from '../components/ComposerLoadingSkeleton.js'

import { InactiveChat } from './InactiveChat.js'
import { NotContactable } from './NotContactable.js'

interface Props {
  chat: Chat
  children: React.ReactNode
}

export const ChatComposerWrapper = ({ chat, children }: Props) => {
  const { $t } = useI18n()
  const isGroup = chat.type === ChatType.Group
  const isInactive = isGroup && chat.status === ChatStatus.Tombstone
  const peerParticipant = chat.otherParticipant
  const { data: contactability, isFetching } = useCheckMembersContactability({
    variables: {
      memberIds: [peerParticipant?.memberId],
    },
    useQueryOptions: {
      enabled: !isGroup && !!peerParticipant?.memberId,
    },
  })
  const notContactable = contactability?.data?.find(
    cm =>
      cm.memberId === peerParticipant?.memberId &&
      cm.status !== ContactabilityStatus.Contactable,
  )

  if (isFetching) {
    return <ComposerLoadingSkeleton />
  }

  if (isInactive) {
    return (
      <InactiveChat
        message={$t({
          defaultMessage: 'You’re no longer in this group.',
          id: 'Messaging.Chat.Inactive.Message.NotMember',
        })}
      />
    )
  }

  if (notContactable) {
    return <NotContactable chatId={chat._id} contactability={notContactable} />
  }

  return <>{children}</>
}
